export const noDataLabel = '[Data is niet beschikbaar]';
